module.exports = __webpack_public_path__ + "static/media/wave-shadowed.aafd2bc3.svg";